import type { NameType, Payload, ValueType } from "recharts/types/component/DefaultTooltipContent"

import { formatUSD } from "../../utils/format-helpers"

/**
 * Shared Recharts formatter for ChartTooltip that displays values as USD.
 * Used by all use-case charts that show monetary values.
 *
 * Must be passed to <ChartTooltip formatter={usdFormatter}> (NOT to ChartTooltipContent)
 * because Recharts cloneElement overrides content props.
 */
export function usdFormatter(
  value: ValueType | undefined,
  name: NameType | undefined,
  item: Payload<ValueType, NameType>
) {
  return (
    <>
      <div className="size-2.5 shrink-0 rounded-[2px]" style={{ backgroundColor: item.color }} />
      <div className="flex flex-1 justify-between leading-none">
        <span className="text-muted-foreground">{String(name)}</span>
        <span className="text-foreground font-mono font-medium tabular-nums">
          {formatUSD(Number(value))}
        </span>
      </div>
    </>
  )
}
